// React
import { useState, useEffect, useRef, useContext } from "react";

// Components and styled components
import { ReactComponent as StarIcon } from "./star.svg";
import { SingleStar, KanbanStars } from "./ApplicationStars.styled";

// Context
import { useKanbanDispatch } from "../../../context/KanbanContext";
import { DispatchPositionContext } from "../../../context/PositionContext";

/**
 * This component can be disabled ( shared shortlist ), unset ( no star rating given ) or has stars 1 - 5
 * @returns jsx
 */
const ApplicationStars = ({ application: applicationProp, id, loading, disabled }) => {
  const application = applicationProp || id;
  const positionDispatch = useContext(DispatchPositionContext);
  const { updateCompactApplication } = useKanbanDispatch();
  const hasApplication = Boolean(application);
  const isLoadingState = loading || !hasApplication;
  const initialStars = application?.stars || 0;
  const [rating, setRating] = useState(initialStars);
  const [tempRating, setTempRating] = useState(initialStars);
  const committedRatingRef = useRef(initialStars);

  useEffect(() => {
    const stars = application?.stars || 0;
    setRating(stars);
    setTempRating(stars);
    committedRatingRef.current = stars;
  }, [application?.stars]);

  return (
    <KanbanStars disabled={disabled} $loading={isLoadingState}>
      <span>
        {[1, 2, 3, 4, 5].map((i) => {
          return (
            <Star
              key={i}
              starNum={i}
              rating={rating}
              isOn={!isLoadingState && i <= tempRating}
              setRate={setRating}
              setTempRate={setTempRating}
              committedRatingRef={committedRatingRef}
              updateCompactApplicationStars={updateCompactApplication}
              applicationId={application?.id}
              updateSelectedApplication={positionDispatch}
              disabled={disabled || isLoadingState}
              loading={isLoadingState}
            />
          );
        })}
      </span>
    </KanbanStars>
  );
};

export default ApplicationStars;

const Star = ({ starNum, isOn, setRate, setTempRate, committedRatingRef, updateCompactApplicationStars, applicationId, updateSelectedApplication, disabled, loading }) => {
  const handleMouseOver = () => {
    if (disabled) {
      return;
    }
    setTempRate(starNum);
  };

  const handleMouseClick = () => {
    if (disabled || !applicationId) {
      return;
    }
    const newRate = committedRatingRef.current === starNum ? 0 : starNum;
    committedRatingRef.current = newRate;
    setRate(newRate);
    setTempRate(newRate);
    updateCompactApplicationStars({ applicationId, stars: newRate });
    updateSelectedApplication({
      type: "update_selected_application",
      payload: { id: applicationId, stars: newRate },
    });
  };

  const handleMouseOut = () => {
    setTempRate(committedRatingRef.current);
  };

  return (
    <SingleStar $loading={loading} isOn={isOn} onClick={handleMouseClick} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
      <StarIcon />
    </SingleStar>
  );
};
